import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RutaSesionTipoEnum } from 'enums/rutaSesionTipo';

export interface IRubricaSegData {
	rutaKey: string;
	cursoKey: string;
	tipoKey: string;
	tipoActividad: 'grupal' | 'individual';
	numeroSesion: number;
	numeroRutaSesion: number;
	isVistaTablaEquipo: boolean;
	grupoKey: string | undefined;
	actividadEvaluacionKey: string | undefined;
	rutaSesionKey: string | undefined;
	tipoSesion?: RutaSesionTipoEnum;
}
export interface DisplayRubricaSeg {
	display: boolean;
	path: IRubricaSegData | undefined;
}

const initialState: DisplayRubricaSeg = {
	display: false,
	path: undefined
};

const displayRubricaSegSlice = createSlice({
	name: 'displayRubricaSeg',
	initialState,
	reducers: {
		setDisplayRubricaSeg: (state, action: PayloadAction<DisplayRubricaSeg>) => {
			return action.payload;
		},
		updatePositionDisplayRubricaSeg: (state, action) => {
			if (!state.path) return state;
			const { numeroSesion, actividadEvaluacionKey, rutaSesionKey, tipoSesion } = action.payload;

			return {
				...state,
				display: true,
				path: {
					...state.path,
					numeroSesion,
					actividadEvaluacionKey,
					rutaSesionKey,
					tipoSesion
				}
			};
		},
		updateStudentDisplayRubricaSeg: (state, action) => {
			if (!state.path) return state;
			const { estudianteKey: newKey, grupoKey: newGrupoKey } = action.payload;
			return {
				...state,
				display: true,
				path: {
					...state.path,
					tipoKey: newKey,
					grupoKey: newGrupoKey
				}
			};
		},
		resetDisplayRubricaSeg: () => {
			return initialState;
		}
	}
});

export const {
	setDisplayRubricaSeg,
	updatePositionDisplayRubricaSeg,
	updateStudentDisplayRubricaSeg,
	resetDisplayRubricaSeg
} = displayRubricaSegSlice.actions;

export default displayRubricaSegSlice.reducer;
